import { apiGET } from './api';

export const getDonors = () => apiGET('/donors');
